export default {"src":"/_next/static/media/live.7468cca3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};